// extracted by mini-css-extract-plugin
export var accordion = "_hl-0";
export var chevron = "_hl-3";
export var closed = "_hl-2";
export var content = "_hl-4";
export var open = "_hl-1";
export var rotate = "_hl-5";